export default "__VITE_ASSET__D6A7wQAs__"